import ApiKeys from './api-keys.json';
import Global from './global.json';
import UserGroup from './user-group.json';
import User from './user.json';

const messagesJA: Record<string, string> = {
  ...Global,
  ...ApiKeys,
  ...User,
  ...UserGroup,
};

export { messagesJA };
